import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import get from 'lodash/get'
import Header from './Header.component'

function mapStateToProps (state) {
  return ({
    companyName: get(state.company, 'company.name'),
    companyId: get(state.company, 'company.id'),
    logo: get(state.company, 'company.logo'),
    mainColor: get(state.company, 'company.main_color'),
    name: get(state.company, 'company.app_user_name'),
    isCobbleDisplayed: get(state.company, 'company.is_cobble_displayed')
  })
}

function mapDispatchToProps (dispatch) {
  return ({
    redirectTo: () => {
      dispatch(push('/'))
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
